import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    OnInit,
} from '@angular/core';
import { SharedUiModule } from '@pf/shared-ui';
import { CpwTaskStateService, ITaskFilter, TaskFilters } from '@cpw/domain';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectOption } from '@pf/shared-common';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, map } from 'rxjs';
import { asArraySafe } from '@pf/shared-utility';
import { EquipmentTypeFacade } from '@pf/platform-wms/domain';

@UntilDestroy()
@Component({
    standalone: true,
    selector: 'cpw-equipment-type-filter',
    template: `
        <pf-select
            [placeholder]="'Equipment Types'"
            pfStyle="compact"
            [tagAmount]="3"
            [multiple]="true"
            [searchFacade]="equipmentTypeFacade"
            [control]="selectControl"
            (selectedMultiple)="onFilterChange($event)"></pf-select>
    `,
    styles: [
        `
            :host {
                width: 100%;
                max-width: 400px;

                pf-select {
                    --pf-form-control-minimum-width: 100%;
                    --pf-form-control-margin-bottom: 0;
                }
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SharedUiModule],
})
export class CpwEquipmentTypeFilterComponent implements ITaskFilter, OnInit {
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly taskService = inject(CpwTaskStateService);
    protected readonly equipmentTypeFacade = inject(EquipmentTypeFacade);
    selectControl = new FormControl<string[]>([]);

    filter: keyof TaskFilters = 'equipmentTypes';

    value?: string;

    ngOnInit(): void {
        this.taskService.taskFilters$
            .pipe(
                untilDestroyed(this),
                map(filters => filters.equipmentTypes),
                distinctUntilChanged((a, b) => {
                    return JSON.stringify(a) === JSON.stringify(b);
                })
            )
            .subscribe(equipmentTypes => {
                this.selectControl.setValue(asArraySafe(equipmentTypes));
                this.cdr.markForCheck();
            });
    }

    onFilterChange(value: SelectOption[]) {
        this.taskService.setFilter({
            filter: this.filter,
            value: value.map(option => option.value),
        });
    }
}
